import React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form/lib/FieldArray'
// components
import { ReduxEntitySelect, ReduxSelect } from 'components/FormElements'
// graphql
import { BUSINESS_UNITS_SELECT_QUERY } from 'graphql/businessUnit/queries'
// views
import { AddButton, CloseIcon, FieldsWrapper, RulesWrapper, RuleWrapper } from './views'
// utils
import { required } from 'utils/validators'
import { businessUnitProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const DEFAULT_RULE = {
  action: { label: 'Is', value: 'IS' },
  property: { label: 'Business Unit', value: 'BUSINESS_UNIT' }
}

interface RuleProps {
  field: string
  removeRule: () => void
}

const Rule: React.FC<RuleProps> = ({ field, removeRule }) => {
  return (
    <RuleWrapper>
      <FieldsWrapper>
        <span>Where</span>
        <ReduxSelect
          placeholder='Property'
          name={`${field}.property`}
          options={[{ label: 'Business Unit', value: 'BUSINESS_UNIT' }]}
        />
        <ReduxSelect name={`${field}.action`} options={[{ label: 'Is', value: 'IS' }]} />
        <ReduxEntitySelect
          validate={[required]}
          fetchPolicy='cache-first'
          placeholder='Business Unit'
          name={`${field}.businessUnit`}
          query={BUSINESS_UNITS_SELECT_QUERY}
          {...businessUnitProps}
        />
      </FieldsWrapper>
      <CloseIcon onClick={removeRule} />
    </RuleWrapper>
  )
}

const Rules: React.FC<WrappedFieldArrayProps> = ({ fields }) => {
  const addRule = () => fields.push(DEFAULT_RULE)

  const removeRule = (idx: number) => () => fields.remove(idx)

  return (
    <RulesWrapper>
      {fields.map((field, idx) => (
        <Rule key={field} field={field} removeRule={removeRule(idx)} />
      ))}
      <AddButton onClick={addRule}>+ add rule</AddButton>
    </RulesWrapper>
  )
}

export default Rules
